import {
    COMMON_FIELDS_INCIDENT,
    getIncidentFieldsForClaimType,
    INCIDENT_DETAIL_LABELS,
    incidentFieldsForClaimType,
    OTHER_DETAIL_LABELS,
    otherFieldsForClaimType,
    PAGE_INDICES,
} from '../../../actions/allSureMotorClaim/types';
import {
    navigateToCategoryPage,
    navigateToBasicDetails,
    navigateToIncidentDetails,
    navigateToOtherDetails,
    navigateToConfirmation,
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToUploadDocuments,
    transitionScrolling,
    navigateToSuccessPage,
} from '../../../actions/allSureMotorClaim/routing';

import { getActivePageIndex } from '../../../selectors/allSureMotorClaim/routing';
import { FIELD_STATUS } from '../../../reducers/status';

import { getUploadDocumentForm } from '../../../selectors/allSureMotorClaim/uploadDocuments';
import { setBasicDetailsFieldValue } from '../../../actions/allSureMotorClaim/basicDetails';
import { getBasicDetailsForm, getSelectedCategoryType } from '../../../selectors/allSureMotorClaim/basicDetails';
import { getIncidentDetailsForm } from '../../../selectors/allSureMotorClaim/incidentDetails';
import { setIncidentDetailsValue } from '../../../actions/allSureMotorClaim/incidentDetails';
import { setOtherDetailsValue } from '../../../actions/allSureMotorClaim/otherDetails';
import { getOtherDetailsForm } from '../../../selectors/allSureMotorClaim/otherDetails';
import { setAmcDocumentValue } from '../../../actions/allSureMotorClaim/uploadDocuments';
import { submitPolicy, uploadDocumentsRequest } from '../../../actions/allSureMotorClaim/policyRequest';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) {
        return next(action);
    }

    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }

    onNavigatePrevious(store, state, activePageIndex);

    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    const uploadDocumentsFormFields = getUploadDocumentForm(state);
    const uploadDocumentsKeys = Object.keys(uploadDocumentsFormFields);
    const basicDetailsFormFields = getBasicDetailsForm(state);
    const incidentDetailsForm = getIncidentDetailsForm(state);
    const CLAIM_TYPE = getSelectedCategoryType(state) ?? 'DEFAULT';
    // console.log('incidentDetailsForm', incidentDetailsForm)
    const dynamicIncident = Object.keys(incidentDetailsForm).filter(
        (key) => key.startsWith('witness') || key.startsWith('passenger')
    );
    // console.log('dynamicIncident' , dynamicIncident)
    // console.log(CLAIM_TYPE, 'claim type')
    const incidentDetailsFormFields = [...incidentFieldsForClaimType[CLAIM_TYPE], ...dynamicIncident];
    // console.log(incidentDetailsFormFields, 'incidentDetailsFormFields')
    const otherDetailsForm = getOtherDetailsForm(state);
    const dynamicOther = Object.keys(otherDetailsForm).filter((key) => key.startsWith('witness'));
    // console.log('dynamicOther' , dynamicOther)
    const otherDetailsFormFields = [...otherFieldsForClaimType[CLAIM_TYPE], ...dynamicOther];
    // const otherDetailsFormFields=Object.keys(OTHER_DETAIL_LABELS)
    const categoryPageFields = ['categoryType', 'privacyNotice'];
    const basicDetailsFields = ['policyNumber', 'fullName', 'mobileNumber', 'email'];
    const confirmationPageFields = ['tnc', 'consentNotice'];
    switch (activePageIndex) {
        case PAGE_INDICES.CATEGORY:
            validateFormDetails(store, basicDetailsFormFields, categoryPageFields, setBasicDetailsFieldValue) &&
                store.dispatch(navigateToBasicDetails());
            break;

        case PAGE_INDICES.BASIC_DETAILS:
            validateFormDetails(store, basicDetailsFormFields, basicDetailsFields, setBasicDetailsFieldValue) &&
                store.dispatch(navigateToIncidentDetails());
            break;

        case PAGE_INDICES.INCIDENT_DETAILS:
            validateFormDetails(store, incidentDetailsForm, incidentDetailsFormFields, setIncidentDetailsValue) &&
                store.dispatch(navigateToOtherDetails());
            break;

        case PAGE_INDICES.OTHER_DETAILS:
            validateFormDetails(store, otherDetailsForm, otherDetailsFormFields, setOtherDetailsValue) &&
                store.dispatch(navigateToUploadDocuments());
            break;

        case PAGE_INDICES.UPLOAD_DOCUMENTS:
            validateFormDetails(store, uploadDocumentsFormFields, uploadDocumentsKeys, setAmcDocumentValue) &&
                store.dispatch(navigateToConfirmation());
            break;

        case PAGE_INDICES.CONFIRMATION:
            validateFormDetails(store, basicDetailsFormFields, confirmationPageFields, setBasicDetailsFieldValue) &&
                store.dispatch(uploadDocumentsRequest());
            break;

        case PAGE_INDICES.SUCCESS:
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.CATEGORY:
            break;

        case PAGE_INDICES.BASIC_DETAILS:
            store.dispatch(navigateToCategoryPage());
            break;

        case PAGE_INDICES.INCIDENT_DETAILS:
            store.dispatch(navigateToBasicDetails());
            break;

        case PAGE_INDICES.OTHER_DETAILS:
            store.dispatch(navigateToIncidentDetails());
            break;

        case PAGE_INDICES.UPLOAD_DOCUMENTS:
            store.dispatch(navigateToOtherDetails());
            break;

        case PAGE_INDICES.CONFIRMATION:
            store.dispatch(navigateToUploadDocuments());
            break;

        case PAGE_INDICES.SUCCESS:
            store.dispatch(navigateToConfirmation());
            break;
    }
};

const validateFormDetails = (store, formFields, validationFieldKeys, validatorAction) => {
    const validate = (fieldValue, fieldType) => {
        const {
            status,
            value = null,
            displayValue = null,
            fileName = null,
            fileContaint = null,
            file = null,
        } = fieldValue[fieldType];
        return status !== FIELD_STATUS.VALID
            ? store.dispatch(
                  validatorAction({
                      fileName,
                      fileContaint,
                      file,
                      inputType: fieldType,
                      fieldType,
                      value,
                      displayValue,
                  })
              )
            : [];
    };
    const inValidFields = validationFieldKeys?.flatMap((field) => {
        const dependentField = formFields[formFields[field]?.dependentField];
        const dependentValue = formFields[field]?.dependentValue;
        const defaultValidationCondition = (dependentValue, actualValue) => dependentValue === actualValue.value;
        const validationCondition = formFields[field]?.validationCondition ?? defaultValidationCondition;
        if (dependentField) {
            return validationCondition(dependentValue, dependentField) ? validate(formFields, field) : [];
        } else {
            return validate(formFields, field);
        }
    });
    store.dispatch(transitionScrolling.scrollToId(inValidFields[0]?.value?.fieldType));
    return !inValidFields.length;
};
